import { useEffect } from "react";
import style from "./aside.module.scss";
import { NavLink, useLocation } from "react-router-dom";

declare const KTScroll: any;

function Aside() {

  const { pathname } = useLocation()

  useEffect(() => {
    const scrollElement = document.querySelector("#kt_aside_menu_wrapper");
    const scroll = KTScroll.getInstance(scrollElement);

    if (scroll) {
      setTimeout(() => scroll.update(), 100);
    }
  }, []);

  return (
    <div
      className={"aside aside-default aside-hoverable " + style.Aside}
      data-kt-drawer="true"
      data-kt-drawer-activate="{default: true, lg: false}"
      data-kt-drawer-direction="start"
      data-kt-drawer-name="aside"
      data-kt-drawer-overlay="true"
      data-kt-drawer-toggle="#kt_aside_toggle"
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      id="kt_aside"
    >
      <div
        className="aside-logo flex-column-auto px-10 pt-9 pb-5"
        id="kt_aside_logo"
      >
        <a href="/">
          <img
            alt="Logo"
            className="max-h-50px logo-default theme-light-show lz"
            src="/assets/media/logos/logo-default.svg"
          />
          <img
            alt="Logo"
            className="max-h-50px logo-default theme-dark-show"
            src="/assets/media/logos/logo-default-dark.svg"
          />
          {/* <img
            alt="Logo"
            className="max-h-50px logo-minimize"
            src="/assets/media/logos/logo-minimize.svg"
          /> */}
        </a>
      </div>
      <div className="aside-menu flex-column-fluid ps-3 pe-1">
        <div
          className="menu menu-sub-indention menu-column menu-rounded menu-title-gray-600 menu-icon-gray-500 menu-active-bg menu-state-primary menu-arrow-gray-500 fw-semibold fs-6 my-5 mt-lg-2 mb-lg-0"
          data-kt-menu="true"
          id="kt_aside_menu"
        >
          <div
            className="hover-scroll-y mx-4"
            data-kt-scroll="true"
            data-kt-scroll-activate="{default: false, lg: true}"
            data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
            data-kt-scroll-height="auto"
            data-kt-scroll-offset="20px"
            data-kt-scroll-wrappers="#kt_aside_menu"
            id="kt_aside_menu_wrapper"
          >
            {/* <div className="alert alert-info p-5 py-3 mb-0">
              <div className="text-center">
                <span>
                  <b>{currentPeriod.name}</b>
                </span>
              </div>
            </div> */}
            <div className="menu-item pt-5">
              <div className="menu-content">
                <span className="fw-bold text-muted text-uppercase fs-7">
                  Operación
                </span>
              </div>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/balance"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-chart-pie-3 fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Balance general</span>
              </NavLink>
            </div>
            {/* <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/register"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-tablet-text-up fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Cortes</span>
              </NavLink>
            </div> */}
            <div
              className={`menu-item menu-accordion ${pathname.startsWith('/register') ? "show": ""}`}
              data-kt-menu-trigger="click"
            >
              <span className="menu-link">
                <span className="menu-icon">
                  <i className="ki-duotone ki-tablet-text-up fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Cortes</span>
                <span className="menu-arrow" />
              </span>
              <div className="menu-sub menu-sub-accordion">
                <div className="menu-item">
                  <NavLink
                    className={() =>
                      `menu-link ${pathname === '/register' ? "active" : ""}`
                    }
                    to={"/register"}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">General</span>
                  </NavLink>
                </div>
                <div className="menu-item">
                  <NavLink
                    className={() =>
                      `menu-link ${pathname === '/register/report' ? "active" : ""}`
                    }
                    to={"/register/report"}
                  >
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Reporte por Productor/Huerta</span>
                  </NavLink>
                </div>
              </div>
            </div>

            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/partner-accounts"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-profile-user fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">
                  Cuentas de socios y colaboradores
                </span>
              </NavLink>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/expenses"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-bill fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Gastos y compras</span>
              </NavLink>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/loans"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-bank fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Prestamos y créditos</span>
              </NavLink>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/reminders"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-notification-on fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Recordatorios</span>
              </NavLink>
            </div>
            <div className="menu-item pt-5">
              <div className="menu-content">
                <span className="fw-bold text-muted text-uppercase fs-7">
                  Configuración
                </span>
              </div>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/configuration/partners"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-medal-star fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Socios y colaboradores</span>
              </NavLink>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/configuration/users"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-user-square fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Usuarios de sistema</span>
              </NavLink>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/configuration/customers"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-delivery fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Productores</span>
              </NavLink>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/configuration/packaging"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-cube-2 fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Empaques</span>
              </NavLink>
            </div>
            <div className="menu-item">
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/configuration/bills"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-financial-schedule fs-2">
                    <span className="path1" />
                    <span className="path2" />
                    <span className="path3" />
                    <span className="path4" />
                    <span className="path5" />
                    <span className="path6" />
                  </i>
                </span>
                <span className="menu-title">Gestión de Gastos y Compras</span>
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/configuration/accounts"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-wallet fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                    <span className="path4"></span>
                  </i>
                </span>
                <span className="menu-title">
                  Cuentas de préstamos y créditos.
                </span>
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  `menu-link ${isActive ? "active" : ""}`
                }
                to={"/configuration/cycle"}
              >
                <span className="menu-icon">
                  <i className="ki-duotone ki-brifecase-tick fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                  </i>
                </span>
                <span className="menu-title">Periodos / Negocio</span>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aside;
